import { mapActions, mapState } from 'vuex'

export default {
  computed: {
    ...mapState('document', {
      activities: 'activities',
    }),
    mapActivities() {
      return this.activities
        .filter((item) => (
          !['create_log', 'update_log', 'update_log_status', 'deleted_log', 'create_file', 'delete_file']
            .includes(item.action_type)
        ))
        .map((item) => {
          const text = (() => {
            const code = this.refCode
            const date = this.getFriendlyTime(item.created_at)
            const status = (() => {
              const hasDetail = item.action_detail
              if (hasDetail) {
                const docCode = (() => {
                  if (this.refDoc === 'inv') {
                    return 'in'
                  } else if (this.refDoc === 'exp') {
                    return 'ex'
                  }
                  return this.refDoc
                })()
                const statusVal = (() => {
                  const key = (() => {
                    if (this.refDoc === 'lot' || this.refDoc === 'ser') {
                      return 'is_ready'
                    }
                    return 'to_status'
                  })()
                  if (this.refDoc === 'lot' || this.refDoc === 'ser') {
                    if (JSON.parse(item.action_detail)[key] === true) {
                      return 'ready'
                    } else {
                      return 'notready'
                    }
                  }
                  return JSON.parse(item.action_detail)[key]
                })()
                return this.$t(`status.${docCode}.${statusVal}`)
              }
            })()
            if (['create_doc'].includes(item.action_type)) {
              return this.$t('docactivity.actiontype.create_doc', { code, date })
            }
            else if (['update_doc'].includes(item.action_type)) {
              return this.$t('docactivity.actiontype.update_doc', { code, date })
            }
            else if (['update_doc_status'].includes(item.action_type)) {
              return this.$t('docactivity.actiontype.update_doc_status', { code, date, status })
            }
            else if (['create_log'].includes(item.action_type)) {
              return this.$t('docactivity.actiontype.create_log', { date })
            }
            else if (['update_log'].includes(item.action_type)) {
              return this.$t('docactivity.actiontype.update_log', { date })
            }
            else if (['update_log_status'].includes(item.action_type)) {
              return this.$t('docactivity.actiontype.update_log_status', { date })
            }
            else if (['deleted_log'].includes(item.action_type)) {
              return this.$t('docactivity.actiontype.deleted_log', { date })
            }
            else if (['create_file'].includes(item.action_type)) {
              return this.$t('docactivity.actiontype.create_file', { date })
            }
            else if (['delete_file'].includes(item.action_type)) {
              return this.$t('docactivity.actiontype.delete_file', { date })
            }
            return ''
          })()
          return {
            ...item,
            text,
          }
        })
    },
  },

  async mounted() {
    await this.fetchAcitivityList()
  },

  methods: {
    ...mapActions('document', {
      getActivityList: 'getActivityList',
    }),
    fetchAcitivityList() {
      return this.getActivityList({
        ref_doc: this.refDoc,
        ref_id: this.refId,
      })
    },
    handleClickUploadFile() {
      console.log('handleClickUploadFile')
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/docRefActivity.js